import { useTheme } from '@simplywallst/ui-core';
import { VerticalStackBarChart } from '../../VerticalStackBarChart';
import {
  KEYS_MAP,
  keys,
  columnStackKeys,
  getEntities,
  getEntitiesFormatted,
  getKeyByPeriod,
} from './utils';
import { extractDividendQualityByPeriod } from '../../../utils/extractPorfolioDividendData';
import { INITIAL_PERIOD } from '../../../constants/portfolioDividend';
import { useCallback } from 'react';
import type { Period } from '../../../types/portfolioDividend';
import { usePortfolioHoldingsDividendForecastCreator } from '../../../hooks/usePortfolioHoldingsDividendForecast';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import type { DemoPortfolio } from '@/hooks/portfolio/useDemoPortfolio';

interface Props {
  onColumnSelected: (key: Period) => void;
  portfolio: Portfolio | DemoPortfolio;
}

export const DividendQualityForecastBarChart = ({
  onColumnSelected,
  portfolio,
}: Props) => {
  const theme = useTheme();
  const { id: portfolioId, currencyISO } = portfolio;

  const { data: portfolioDividendHoldingForecast } =
    usePortfolioHoldingsDividendForecastCreator(currencyISO)({ portfolioId });

  const portfolioDividendData = extractDividendQualityByPeriod(
    portfolioDividendHoldingForecast
  );

  const columnStackColors = [
    theme.color.good,
    theme.color.warning,
    theme.color.bad,
  ];

  const entities = getEntities(portfolioDividendData);

  const entitiesFormatted = getEntitiesFormatted(
    portfolioDividendData,
    currencyISO
  );

  const onSelectingColumn = useCallback(
    (key: string) => {
      onColumnSelected(KEYS_MAP[key]);
    },
    [onColumnSelected]
  );

  return (
    <VerticalStackBarChart
      entities={entities}
      entitiesFormatted={entitiesFormatted}
      keys={keys}
      height={250}
      columnStackColors={columnStackColors}
      columnStackKeys={columnStackKeys}
      onSelectingColumn={onSelectingColumn}
      initialSelectedColumn={getKeyByPeriod(INITIAL_PERIOD)}
    />
  );
};
